module.exports = __webpack_public_path__ + "img/wave2.fd397f44.svg";